<form #studentForm="ngForm" class="mt-0" (ngSubmit)="submitForm(studentForm.valid)">

    <p-accordion value="-1">
        <p-accordion-panel value="0">
            <p-accordion-header>Bio Details</p-accordion-header>
            <p-accordion-content>
                <div class="grid grid-cols-1 md:grid-cols-2 gap-6">
                    <div *ngIf="isFixedColumn" class="col-span-1">
                        <label class="block mb-2">Prefix</label>
                        <p-select class="w-full profile-select" appendTo="body"
                            [(ngModel)]="createFieldFormValue['prefix']" name="prefix"
                            [options]="prefixOptions"></p-select>
                    </div>

                    <div *ngIf="isFixedColumn" class="col-span-1">
                        <label class="block mb-2 requiredValue">First Name</label>
                        <input pInputText class="w-full profile-input" style="box-shadow: none !important;"
                            [(ngModel)]="createFieldFormValue['first_name']" name="first_name" required
                            pattern="^[a-zA-Z ]*$" #first_name="ngModel"
                            [ngClass]="{'ng-invalid ng-dirty' : isSubmitted && !createFieldFormValue['first_name']}" />
                        <small class="text-red-500" *ngIf="isSubmitted && !createFieldFormValue['first_name']">Enter First Name</small>
                        <small class="text-red-500" *ngIf="first_name?.errors?.['pattern']">Special characters are not allowed.</small>
                    </div>

                    <div *ngIf="isFixedColumn" class="col-span-1">
                        <label class="block mb-2 requiredValue">Last Name</label>
                        <input pInputText class="w-full profile-input" style="box-shadow: none !important;"
                            [(ngModel)]="createFieldFormValue['last_name']" name="last_name" required
                            pattern="^[a-zA-Z ]*$" #last_name="ngModel"
                            [ngClass]="{'ng-invalid ng-dirty' : isSubmitted && !createFieldFormValue['last_name'] }" />
                        <small class="text-red-500" *ngIf="isSubmitted && !createFieldFormValue['last_name']">Enter Last Name</small>
                        <small class="text-red-500" *ngIf="last_name?.errors?.['pattern']">Special characters are not allowed.</small>
                    </div>

                    <div *ngIf="isFixedColumn" class="col-span-1">
                        <label class="block mb-2">Guardian Name</label>
                        <input pInputText class="w-full shadow-none profile-input"
                            [(ngModel)]="createFieldFormValue['guardian_name']" name="guardian_name" />
                    </div>

                    <div *ngIf="isFixedColumn" class="col-span-1">
                        <label class="block mb-2">Guardian Contact</label>
                        <input pInputText class="w-full shadow-none profile-input"
                            [(ngModel)]="createFieldFormValue['guardian_contact']" name="guardian_contact"
                            type="number" />
                    </div>

                    <div *ngIf="isFixedColumn" class="col-span-1">
                        <label class="block mb-2">Date of Birth</label>
                        <p-datepicker class="w-full  " appendTo="body" [inputStyle]="{
                                    'box-shadow':'none !important',
                                    'width': '100%',
                                    'border': 'none',
                                    'background-color': 'transparent',
                                    'border-radius': '10px',
                                }" [style]="{'box-shadow':'none !important',
                                    'width': '100%',
                                    'background-color': 'transparent',
                                    'border': 'none',
                                    'border-radius': '10px',
                                 }" [maxDate]="today" [(ngModel)]="createFieldFormValue['date_of_birth']"
                            name="date_of_birth" />
                        <div class="w-full profile-input h-[33px] -mt-[32px] z-50 rounded-[5px]">
                        </div>
                    </div>

                    <div *ngIf="isFixedColumn" class="col-span-1">
                        <label class="block mb-2">Age</label>
                        <input pInputText class="w-full profile-input" style="box-shadow: none !important;"
                            [(ngModel)]="createFieldFormValue['age']" name="age" />
                    </div>

                    <div *ngIf="isFixedColumn" class="col-span-1">
                        <label class="block mb-2">Gender</label>
                        <p-select class="w-full profile-select" appendTo="body"
                            [(ngModel)]="createFieldFormValue['gender']" name="gender" [options]="genderOptions" />
                    </div>

                    <div *ngIf="isFixedColumn" class="col-span-1">
                        <label class="block mb-2">Nationality</label>
                        <input pInputText class="w-full profile-input" style="box-shadow: none !important;"
                            [(ngModel)]="createFieldFormValue['nationality']" name="nationality" />
                    </div>

                    <div *ngIf="isFixedColumn" class="col-span-1">
                        <label class="block mb-2">Interested Course</label>
                        <input pInputText class="w-full profile-input" style="box-shadow: none !important;"
                            [(ngModel)]="createFieldFormValue['interested_course']" name="interested_course" />
                    </div>
                </div>
            </p-accordion-content>
        </p-accordion-panel>

        <p-accordion-panel value="1">
            <p-accordion-header>Contact Details</p-accordion-header>
            <p-accordion-content>
                <div class="grid grid-cols-1 md:grid-cols-2 gap-6">
                    <div *ngIf="isFixedColumn" class="col-span-1">
                        <label class="block mb-2 requiredValue">Contact Email</label>
                        <input pInputText class="w-full profile-input" style="box-shadow: none !important;"
                            [(ngModel)]="createFieldFormValue['email']" name="email" required
                            [ngClass]="{'ng-invalid ng-dirty' : isSubmitted && !createFieldFormValue['email']}" />
                        <small class="text-red-500" *ngIf="isSubmitted && !createFieldFormValue['email']">Enter Contact Email</small>
                    </div>

                    <div *ngIf="isFixedColumn" class="col-span-1">
                        <label class="block mb-2 requiredValue">Contact Number</label>
                        <input pInputText class="w-full profile-input" style="box-shadow: none !important;"
                            [ngClass]="{'ng-invalid ng-dirty' : isSubmitted && !createFieldFormValue['phone'] }"
                            [(ngModel)]="createFieldFormValue['phone']" name="phone" required />
                        <small class="text-red-500" *ngIf="isSubmitted && !createFieldFormValue['phone']">Enter Contact Number</small>
                    </div>

                    <div *ngIf="isFixedColumn" class="col-span-1">
                        <label class="block mb-2">Alternate Number</label>
                        <input pInputText class="w-full profile-input" style="box-shadow: none !important;"
                            [(ngModel)]="createFieldFormValue['alternate_phone']" name="alternate_phone" />
                    </div>
                </div>
            </p-accordion-content>
        </p-accordion-panel>

        <p-accordion-panel value="2">
            <p-accordion-header>Demographic Details</p-accordion-header>
            <p-accordion-content>
                <div class="grid grid-cols-1 md:grid-cols-2 gap-6 mt-4">
                    <div *ngIf="isFixedColumn" class="col-span-1">
                        <label class="block mb-2">Preferred Location</label>
                        <input pInputText class="w-full profile-input" style="box-shadow: none !important;"
                            [(ngModel)]="createFieldFormValue['preferred_location']" name="preferred_location" />
                    </div>

                    <div *ngIf="isFixedColumn" class="col-span-1">
                        <label class="block mb-2">City</label>
                        <input pInputText class="w-full profile-input" style="box-shadow: none !important;"
                            [(ngModel)]="createFieldFormValue['city']" name="city" />
                    </div>

                    <div *ngIf="isFixedColumn" class="col-span-1">
                        <label class="block mb-2">State</label>
                        <input pInputText class="w-full profile-input" style="box-shadow: none !important;"
                            [(ngModel)]="createFieldFormValue['state']" name="state" />
                    </div>

                    <div *ngIf="isFixedColumn" class="col-span-1">
                        <label class="block mb-2">Country</label>
                        <input pInputText class="w-full profile-input" style="box-shadow: none !important;"
                            [(ngModel)]="createFieldFormValue['country']" name="country" />
                    </div>

                    <div *ngIf="isFixedColumn" class="col-span-1">
                        <label class="block mb-2">Postal Code</label>
                        <input pInputText class="w-full profile-input" style="box-shadow: none !important;"
                            [(ngModel)]="createFieldFormValue['postal_code']" name="postal_code" />
                    </div>
                </div>
                <div class="grid grid-cols-1 mt-4">
                    <div class="col-span-1">
                        <label class="block mb-2">Address</label>
                        <textarea pTextarea class="w-full profile-input" rows="5" style="box-shadow: none !important;"
                            [(ngModel)]="createFieldFormValue['address']" name="address"></textarea>
                    </div>
                </div>
            </p-accordion-content>
        </p-accordion-panel>

    

        <p-accordion-panel value="4">
            <p-accordion-header>Registration Details</p-accordion-header>
            <p-accordion-content>
                <div class="grid grid-cols-1 md:grid-cols-2 gap-6">
                    <div *ngIf="isFixedColumn" class="col-span-1">
                        <label class="block mb-2">Previous Education</label>
                        <input pInputText class="w-full shadow-none profile-input"
                            [(ngModel)]="createFieldFormValue['previous_education']" name="previous_education"
                            type="text" />
                    </div>

                    <div *ngIf="isFixedColumn" class="col-span-1">
                        <label class="block mb-2 requiredValue">Preferred Course</label>
                        <p-select class="w-full shadow-none profile-select" appendTo="body"
                            [(ngModel)]="createFieldFormValue['preferred_course']" name="preferred_course"
                            [options]="allCourses" optionLabel="name" optionValue="course_id" required
                            [ngClass]="{'ng-invalid ng-dirty' : isSubmitted && !createFieldFormValue['preferred_course']}">
                        </p-select>
                        <small class="text-red-500" *ngIf="isSubmitted && !createFieldFormValue['preferred_course']">Select Preferred Course</small>
                    </div>

                    <div *ngIf="isFixedColumn" class="col-span-1">
                        <label class="block mb-2 requiredValue">Registration Status</label>
                        <p-select class="w-full shadow-none profile-select" appendTo="body"
                            [(ngModel)]="createFieldFormValue['status']" name="status"
                            [options]="registrationStatusList" required
                             [disabled]="true"
                            [ngClass]="{'ng-invalid ng-dirty' : isSubmitted && !createFieldFormValue['status']}">
                        </p-select>
                        <small class="text-red-500" *ngIf="isSubmitted && !createFieldFormValue['status']">Select Status</small>
                    </div>

                    <div *ngIf="isFixedColumn" class="col-span-1">
                        <label class="block mb-2 requiredValue">Document Status</label>
                        <p-select class="w-full shadow-none profile-select" appendTo="body"
                            [(ngModel)]="createFieldFormValue['document_status']" name="document_status"
                            [options]="documentStatusList" required
                            [disabled]="true"
                            [ngClass]="{'ng-invalid ng-dirty' : isSubmitted && !createFieldFormValue['document_status']}">
                        </p-select>
                       
                    </div>

                    
                </div>
            </p-accordion-content>
        </p-accordion-panel>

       
        <p-accordion-panel value="6">
            <p-accordion-header>Other Details</p-accordion-header>
            <p-accordion-content>
                <div *ngIf="fieldValues" class="grid grid-cols-1 md:grid-cols-2 gap-6 mt-4">
                    <div *ngFor="let item of allLeadFeilds">
                        <div class="col-span-1 w-full">
                            <label class="block mb-2" [ngClass]="{ 'requiredValue': item.required === 'true' }">
                                {{ item.label }}
                            </label>

                            <!-- Regular Input -->
                            <input *ngIf="item.type !== 'select' && item.type !== 'textarea'" pInputText
                                class="w-full profile-input" [(ngModel)]="fieldValues[item.field_name]"
                                [name]="item.field_name" [required]="item.required === 'true' ? true : false"
                                [ngModelOptions]="{ standalone: false }" [ngClass]="{
                                    'ng-invalid ng-dirty': isSubmitted && item.required === 'true' && !fieldValues[item.field_name]
                                  }" />

                            <!-- Textarea -->
                            <textarea *ngIf="item.type === 'textarea'" pTextarea style="box-shadow: none !important;"
                                class="w-full" [(ngModel)]="fieldValues[item.field_name]" [name]="item.field_name"
                                [required]="item.required === 'true' ? true : false"
                                [placeholder]="item.placeholder"></textarea>

                            <!-- Select -->
                            <p-select *ngIf="item.type === 'select'" class="w-full profile-select" appendTo="body"
                                [required]="item.required === 'true' ? true : false"
                                [(ngModel)]="fieldValues[item.field_name]" [name]="item.field_name"
                                [options]="item.data" [placeholder]="item.placeholder"></p-select>

                            <!-- Validation Message -->
                            <small class="text-red-500"
                                *ngIf="isSubmitted && item.required === 'true' && !fieldValues[item.field_name]">
                                Enter {{ item.label }}
                            </small>
                        </div>
                    </div>
                </div>
            </p-accordion-content>
        </p-accordion-panel>
    </p-accordion>

    <div class="mt-4 w-full">
        <p-button type="submit" [label]="'Update'" class="w-full" [style]="{width: '100%'}" [icon]="'pi pi-pencil'"
            [disabled]="isLoading" [loading]="isLoading" class="p-button-primary w-full md:w-auto"></p-button>
    </div>

</form>
